import { render, staticRenderFns } from "./500.vue?vue&type=template&id=a5b0abc0&scoped=true&"
var script = {}
import style0 from "./500.vue?vue&type=style&index=0&id=a5b0abc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b0abc0",
  null
  
)

export default component.exports